<div class="col-12 book-staircase-wrapper">
  <div class="row no-align-items" id="scroll-book-staircase-{{ data.type }}-{{ cardId }}" #scrollMe>
    <table [ngClass]="{'billit-dom': hasBillet }">
      <thead>
        <tr>
          <th *ngIf="hasBillet">ORD.</th>
          <th>{{ !hasBillet ? 'QTD. COMPRA' : 'QTD. C.' }}</th>
          <th>PREÇO</th>
          <th>{{ !hasBillet ? 'QTD. VENDA' : 'QTD. V.' }}</th>
          <th *ngIf="hasBillet">ORD.</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of priceList; let ind = index;">
          <td class="qtd" [ngClass]="{'withValue': itemsObject[item.price]?.qty_order_purchase }"
            id="buy_{{ item.price }}" (drop)="dropEdit($event, item.price, SideEnum.BUY)" (dragover)="allowDrop($event)"
            *ngIf="hasBillet">
            <div class="number float-l" *ngIf="itemsObject[item.price]?.qty_order_purchase" draggable="true"
              (dragstart)="dragEdit($event)" id="drag_{{ item.price }}" (click)="setPriceOrder(item.price)">
              {{itemsObject[item.price]?.qty_order_purchase }}
            </div>
            <div class="icon float-r dark-svg" *ngIf="itemsObject[item.price]?.qty_order_purchase"
              (click)="cancelOrder(item.price, SideEnum.BUY)">
              <mat-icon matSuffix svgIcon="close" [matTooltip]="'Cancelar Ordem'"></mat-icon>
            </div>
          </td>
          <td class="buy" [ngClass]="{'withValue': itemsObject[item.price]?.purchase }"
            (click)="setPriceOrder(item.price)">
            {{ hasBillet ? (itemsObject[item.price]?.purchase | abbreviateNumber) : (itemsObject[item.price]?.purchase)
            }}
          </td>
          <td class="price {{ item.price == initialValue ? ('middle-' + cardId) : '' }}"
            (dblclick)="setCenterElement(item.price)" [ngClass]="{'bg-min-max': ((highDay > 0 && item.price > highDay) || (lowDay > 0 && item.price < lowDay)),
            'average': item.price == averagePricePos, 'high': item.price == highDay, 'low': item.price == lowDay,
            'open': item.price == openDay, 'center': item.price == centerElement, 'current': item.price == initialValue
          }">
            {{ item.currency }}
          </td>
          <td class="sale" [ngClass]="{'withValue': itemsObject[item.price]?.sale }"
            (click)="setPriceOrder(item.price)">
            {{ hasBillet ? (itemsObject[item.price]?.sale | abbreviateNumber) : (itemsObject[item.price]?.sale) }}
          </td>
          <td class="qtd" [ngClass]="{'withValue': itemsObject[item.price]?.qty_order_sale }" id="sell_{{ item.price }}"
            (drop)="dropEdit($event, item.price, SideEnum.SELL)" (dragover)="allowDrop($event)" *ngIf="hasBillet">
            <div class="number float-r" *ngIf="itemsObject[item.price]?.qty_order_sale" draggable="true"
              (dragstart)="dragEdit($event)" id="drag_{{ item.price }}">
              {{ itemsObject[item.price]?.qty_order_sale }}
            </div>
            <div class="icon float-l dark-svg" *ngIf="itemsObject[item.price]?.qty_order_sale"
              (click)="cancelOrder(item.price, SideEnum.SELL)">
              <mat-icon matSuffix svgIcon="close" [matTooltip]="'Cancelar Ordem'"></mat-icon>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="row" *ngIf="hasBillet">
    <div class="col-6 p-0">
      <app-incremental-input-small [withBackground]="true" placeholder="Quantidade" name="model.qtd"
        ondragstart="return false;" ondrop="return false;" [roundLot]="model.loteDefault" [maxlength]="7"
        (mousewheel)="verifyQuantity()" [invalid]="qtdValid" minValue="0" maxValue="999999"
        (keydown)="validPrice(model.qtd)" (keyup)="verifyQuantity();validPrice(model.qtd);" (click)="verifyQuantity()"
        [isQuantity]="true" [(ngModel)]="model.qtd" aria-required="" [price]="false"
        [isDisabled]="!quantityDisabled() || loading">
      </app-incremental-input-small>
    </div>
    <div class="col-6 p-0">
      <app-incremental-input [withBackground]="true" name="model.price" ondragstart="return false;"
        ondrop="return false;" id="preço" placeholder="Preço" (valueChanged)="validPrice(model.price);verifyQuantity()"
        [roundLot]="+model.minimumIncrement" minValue="0" maxValue="999999" [isQuantity]="true" [price]="true"
        [(ngModel)]="model.price" aria-required="" (keyup)="verifyQuantity()" [minValue]="0"
        (keyup)="validPrice(model.price)" [isDisabled]="!verifyPrice() || loading" [options]="optionsInput">
      </app-incremental-input>
    </div>
  </div>
  <div class="row" *ngIf="hasBillet">
    <app-billet-actions class="col-12" (actionConfirm)="confirmTradeAction($event)" [statusOmsOnline]="statusOmsOnline"
      [isLoggedNegotiation]="isLoggedNegotiation" [termOperator]="termOperator" [positionNetDay]="positionNetDay+''"
      [asset]="model?.quote" [market]="model?.market" (openConfirmationBillit)="openModalConfirm($event)">
    </app-billet-actions>
  </div>
</div>
